var event_programme = ( function( $ ) {

	var _init = function() {
		var $interval_header   = $( '.interval-header' );
		var $subsection_header = $( '.interval-subsection-header' );

		if ( $interval_header.length > 0 ) {
			$interval_header.on( 'click', function( e ) {
				_toggle_open( $( this ), '.interval-body' );
			} );
		}

		if ( $subsection_header.length > 0 ) {
			$subsection_header.on( 'click', function( e ) {
				_toggle_open( $( this ), '.interval-subsection-text' );
			} );
		}
	};

	var _toggle_open = function( $this, className ) {
		var $toggle = $this.parent().find( className );

		$this.find('.toggle-icon').toggleClass( 'open' );
		$toggle.slideToggle();
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = event_programme;